import { CVE_PAGE } from "../../../shared/constants/constant-data";
import { SeverityCellRenderer, CveIdCellRenderer } from "../cell_renderers";
import { TABLE_INFO } from "../shared/table_config";

const { HEADER_LABEL: tableHeader, PROPS: tableProps } = TABLE_INFO.TOP_CVES;

export const topCveColumnDefs = [
  {
    headerName: tableHeader.CVE_ID,
    field: tableProps.CVE_ID,
    headerTooltip: tableHeader.CVE_ID,
    cellRenderer: CveIdCellRenderer,
    lockPinned: true,
    suppressColumnsToolPanel: true,
    lockPosition: true,
    cellClass: ["ag-bold", "fs-13"],
    flex: 3,
    filter: false,
    sortable: true,
  },
  {
    headerName: tableHeader.CVSS,
    field: tableProps.CVSS,
    headerTooltip: tableHeader.CVSS,
    flex: 2,
    filter: false,
    sortable: true,
    comparator: (valueA: string, valueB: string) => {
      const numA = parseFloat(valueA) || 0;
      const numB = parseFloat(valueB) || 0;
      return numA - numB;
    },
    // cellClass: ["ag-grey", "fs-12"],
  },
  {
    headerName: tableHeader.SEVERITY,
    field: tableProps.SEVERITY,
    flex: 2.5,
    sortable: true,
    cellRenderer: SeverityCellRenderer,
    filter: true,
    filterParams: {
      values: ["Critical", "High", "Medium", "Low"],
    },
    comparator: (valueA: string, valueB: string) => {
      const severityOrder = { "Critical": 4, "High": 3, "Medium": 2, "Low": 1 };
      const orderA = severityOrder[valueA as keyof typeof severityOrder] || 0;
      const orderB = severityOrder[valueB as keyof typeof severityOrder] || 0;
      return orderA - orderB;
    },
  },
  {
    headerName: tableHeader.CISSA_KEV,
    field: tableProps.CISSA_KEV,
    headerTooltip: CVE_PAGE.cisaKevHeaderTooltip,
    flex: 3,
    cellClass: (params: { data: { cisas_kev: string } }) => {
      const exploitClass = params.data?.cisas_kev ? "ag-red" : "fw-600";
      return [exploitClass, "fs-12"];
    },
    valueGetter: (params: { data: { cisas_kev: string } }) => {
      return params.data?.cisas_kev ? "Exploited" : "Not Exploited";
    },
    sortable: true,
    filter: true,
    filterParams: {
      values: ["Exploited", "Not Exploited"],
    },
    comparator: (valueA: string, valueB: string) => {
      // Sort "Exploited" before "Not Exploited"
      if (valueA === "Exploited" && valueB === "Not Exploited") return -1;
      if (valueA === "Not Exploited" && valueB === "Exploited") return 1;
      return 0;
    },
  },

  {
    headerName: tableHeader.EPSS,
    field: tableProps.EPSS,
    headerTooltip: CVE_PAGE.epssHeaderTooltip.desc,
    tooltipField: tableProps.EPSS,
    filter: false,
    sortable: true,
    flex: 3,
    valueFormatter: (params: { value: number }) => params.value != null ? `${params.value}%` : '',
    comparator: (valueA: number, valueB: number) => {
      const numA = parseFloat(valueA?.toString()) || 0;
      const numB = parseFloat(valueB?.toString()) || 0;
      return numA - numB;
    },
    //cellClass: ["ag-grey", "fs-13"],
  },
  {
    headerName: tableHeader.ASSETS,
    field: tableProps.ASSETS,
    flex: 2,
    sortable: true,
    filter: false,
    // sort: "desc" as const,
    comparator: (valueA: number, valueB: number) => {
      const numA = parseInt(valueA?.toString()) || 0;
      const numB = parseInt(valueB?.toString()) || 0;
      return numB - numA;
    },
    //cellClass: ["ag-grey", "fs-12"],
  },
];
